const CURRENCY_MAP_SLP = {
    currency1: 'HKD', // 港币
    currency2: 'USD', // 美元
    currency3: 'SGD', // 新元
    currency4: 'CNH', // 人民币
    currency5: 'JPY', // 日元
    currency6: 'AUD', // 澳元
    currency7: 'MYR', // 令吉
    currency8: 'CAD' // 加元
};

const FUND_MAP = [
    {
        fund1: '货币基金',
        fund2: '债券基金',
        fund3: '股票基金',
        fund4: '指数基金',
        fund5: '混合基金',
        fund6: 'FOF',
        fund7: 'QDII',
        fund8: '短期理财',
        fund9: '基金组合',
        fund10: '结构化票据',
        fund11: '流动型基金',
        fund12: '商品型基金',
        fund13: '令类型基金',
        fund14: '房地产信托型',
        fund15: '固定净值型货币基金',
        fund66: '私募基金'
    },
    {
        fund1: '货币基金',
        fund2: '债券基金',
        fund3: '股票基金',
        fund4: '指数基金',
        fund5: '混合基金',
        fund6: 'FOF',
        fund7: 'QDII',
        fund8: '短期理财',
        fund9: '基金组合',
        fund10: '结构化票据',
        fund11: '流动型基金',
        fund12: '商品型基金',
        fund13: '令类型基金',
        fund14: '房地产信托型',
        fund15: '固定净值型货币基金',
        fund66: '私募基金'
    },
    {
        fund1: 'MMF',
        fund2: 'Bond Fund',
        fund3: 'Equity Fund',
        fund4: 'ETF',
        fund5: 'Balanced Fund',
        fund6: 'FOF',
        fund7: 'QDII',
        fund8: 'Short-term investment',
        fund9: 'FOF',
        fund10: 'Structured Notes',
        fund11: 'Liquidity Fund',
        fund12: 'Commodity Fund',
        fund13: 'Alternative Fund',
        fund14: 'Reits',
        fund15: 'MMF',
        fund66: 'Private Fund'
    }
];

const RATE_COLOR = {
    RED_UP: 'redup',
    RED_DOWN: 'reddown'
};

const SHOW_ENUM = {
    SHOW: 1,
    HIDE: 0
};

const PRODUCT_TYPE = {
    STOCK: 0,
    ETF: 1,
    CRYPTO: 2,
    FUND: 3,
    BOND: 4,
    SELLER_OPTION: 5,
    BUY_OPTION: 6,
    PLATE_STOCK: 7,
    PLATE_ETF: 8,
    PRIVATE_FUND: 9,
    NOTE: 10
};

const EN_LANG = 2;

const NUM_UNIT = {
    HUNDRED: 100,
    THOUSAND: 1000,
    E9: 1e9,
    E7: 1e7
};

const OPTION_TYPE = {
    CALL: 1,
    PUT: 2
};

const SHOW_TYPE = {
    CODE: 1,
    NAME: 2
};

const MARKET_TYPE = {
    US_STOCK: 0,
    US_ETF: 1,
    US_FUTURE: 2,
    HK_STOCK: 3,
    HK_ETF: 4
};
//0 美股股票期权 1 美股指数期权 2 美股期货期权 3 港股股票期权 4 港股指数期权

// 港股1 美股2
const MARKET_ID_MAP = {
    0: 2,
    1: 2,
    2: 2,
    3: 1,
    4: 1
};

const DEFAULT_NUM = 5;

const TMP_LIST_INFO = {
    stockId: '',
    newcode: '',
    desc: ''
};
const DEFAULT_LEN = 10;
const DEFAULT_PLATE_INFO = [];
for (let i = 0; i < DEFAULT_LEN; i++) {
    DEFAULT_PLATE_INFO.push({ ...TMP_LIST_INFO });
}
const MAX_PLATE_STOCK_NUM = 10;

const NOTE_DISPLAY_ORDER_INSTAUMENT = [58, 66, 65, 63, 59, 60, 61, 62, 64, 67, 68, 69, 70, 71];

export {
    CURRENCY_MAP_SLP,
    FUND_MAP,
    EN_LANG,
    RATE_COLOR,
    PRODUCT_TYPE,
    SHOW_ENUM,
    NUM_UNIT,
    OPTION_TYPE,
    MARKET_TYPE,
    DEFAULT_NUM,
    MARKET_ID_MAP,
    DEFAULT_PLATE_INFO,
    MAX_PLATE_STOCK_NUM,
    TMP_LIST_INFO,
    SHOW_TYPE,
    NOTE_DISPLAY_ORDER_INSTAUMENT
};
